export const getAirlineName = (airline: any) => {
  if (airline?.code === 'I5') return 'Air India Express';
  else return airline?.name;
};
